import { render } from "./index.vue?vue&type=template&id=c9ffc866"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vab/components/VabFullScreen/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9ffc866"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9ffc866', __exports__)) {
    api.reload('c9ffc866', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c9ffc866", () => {
    api.rerender('c9ffc866', render)
  })

}


export default __exports__